/**
 * "Vault by PD" brand mark.
 *
 * Pure text wordmark — no PNG dependency. Use `variant="light"` on dark
 * backgrounds (sidebar, login hero, PDF header strip) and the default
 * `variant="dark"` on light surfaces. Height scales the primary wordmark;
 * the "by PD" tag scales proportionally alongside it.
 */
export default function BrandLogo({
    variant = "dark",
    height = 34,
    className = "",
    alt = "Vault by PD",
    showTag = true,
}) {
    const isLight = variant === "light";
    const primary = isLight ? "#f8fafc" : "#0b1e3f";
    const tagColor = isLight ? "rgba(248,250,252,0.62)" : "rgba(11,30,63,0.55)";
    // Primary wordmark height controls the letter size; letters use tight tracking.
    const fontSize = Math.round(height * 0.82);
    const tagSize = Math.max(9, Math.round(height * 0.28));
    return (
        <span
            role="img"
            aria-label={alt}
            data-testid="brand-logo"
            className={`select-none pointer-events-none inline-flex items-baseline gap-2 ${className}`}
            style={{
                height,
                fontFamily: '"Inter", "IBM Plex Sans", ui-sans-serif, system-ui, sans-serif',
                lineHeight: 1,
            }}
        >
            <span
                style={{
                    fontWeight: 900,
                    fontSize,
                    letterSpacing: "0.22em",
                    color: primary,
                    textTransform: "uppercase",
                }}
            >
                VAULT
            </span>
            {showTag && (
                <span
                    style={{
                        fontWeight: 600,
                        fontSize: tagSize,
                        letterSpacing: "0.28em",
                        color: tagColor,
                        textTransform: "uppercase",
                        transform: "translateY(-2px)",
                    }}
                >
                    by PD
                </span>
            )}
        </span>
    );
}
